import { render } from "./SubjectCategory.vue?vue&type=template&id=0dec3b63&scoped=true"
import script from "./SubjectCategory.vue?vue&type=script&lang=js"
export * from "./SubjectCategory.vue?vue&type=script&lang=js"

import "./SubjectCategory.vue?vue&type=style&index=0&id=0dec3b63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dec3b63"]])

export default __exports__